export default {
  components: [
    {
      data: [
        {
          direction: 'left',
          iconName: '',
          iconUrl: 'https://static.stgairasia.com/seo/static-assets/images/logos/airasiacom_logo.svg',
          id: 'aalogo',
          label: '',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/en/gb',
          showInMobilePane: 'FALSE',
          type: 'logo'
        },
        {
          direction: 'right',
          iconName: '',
          iconUrl: '',
          id: 'tnc',
          label: 'Shopping Guide',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/aa/shop/shopping-guide/index.html',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: '',
          iconUrl: '',
          id: 'tnc',
          label: 'Terms & Conditions',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/shop/my/en/terms-and-conditions',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'ForumIcon',
          iconUrl: '',
          id: 'support',
          label: 'Support',
          newTab: 'TRUE',
          redirectUrl: 'https://support.airasia.com/s/topic/0TO2u0000004F7XGAU/travelmall-malaysia-en?language=en_GB',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'LanguageIcon',
          iconUrl: '',
          id: 'localecurrency',
          label: '',
          newTab: '',
          redirectUrl: '',
          showInMobilePane: 'TRUE',
          type: 'locale-currency'
        },
        {
          direction: 'right',
          iconName: 'AccountCircle',
          iconUrl: '',
          id: 'login',
          label: 'Login/Signup',
          newTab: '',
          redirectUrl: '',
          showInMobilePane: 'FALSE',
          type: 'login'
        }
      ]
    }
  ],

  defaultCurrency: [
    {
      data: [
        {
          icon: 'MonetizationOnIcon',
          longform: 'US Dollar',
          shortSymbol: '$',
          shortform: 'USD'
        }
      ]
    }
  ],
  defaultLocale: [
    {
      data: [
        {
          default: '/',
          icon: 'LanguageIcon',
          longform: 'English',
          shortform: 'EN'
        }
      ]
    }
  ],
  localeList: [
    {
      data: [
        {
          default: '/',
          longform: 'English (Malaysia)',
          shortform: 'EN'
        },
        {
          default: '/id/',
          longform: 'English (Indonesia)',
          shortform: 'EN'
        },
        {
        default: '/th/',
        longform: 'English (Thailand)',
        shortform: 'EN'
        },
        {
          default: '/id/id/',
          longform: 'Bahasa Indonesia',
          shortform: 'ID'
        },
        {
        default: '/th/th/',
        longform: 'ภาษาไทย',
        shortform: 'TH'
        },
      ]
    }
  ],
  loginMenu: [
    {
      memberData: [
        {
          icon: '',
          id: 'bigMemberId',
          label: 'BIG Member ID',
          newTab: 'FALSE',
          redirectUrl: ''
        },
        {
          icon: '',
          id: 'bigMemberPoints',
          label: 'BIG Points',
          newTab: 'FALSE',
          redirectUrl: ''
        },
        {
          icon: '',
          id: 'status',
          label: 'Status',
          newTab: 'FALSE',
          redirectUrl: ''
        }
      ]
    },
    {
      navigations: [
        {
          icon: 'account_box',
          id: 'myaccount',
          label: 'My account',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/myaccount?culture=en-GB'
        },
        {
          icon: 'featured_play_list',
          id: 'mybookings',
          label: 'My bookings',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mybookings?culture=en-GB'
        },
        {
          icon: 'library_books',
          id: 'mysubscription',
          label: 'My subscription',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mysubscription?culture=en-GB'
        },
        {
          icon: 'credit_card',
          id: 'mybigpaycheckout',
          label: 'My BigPay Checkout',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/myaccount#bigpaycheckout'
        },
        {
          icon: 'assignment_turned_in',
          id: 'mycases',
          label: 'My cases',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mycases?culture=en-GB'
        },
        {
          icon: 'money',
          id: 'mybigpoints',
          label: 'My BIG Points',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasiabig.com/my/en/profile'
        },
        {
          icon: 'attach_money',
          id: 'mycreditaccount',
          label: 'My credit account',
          newTab: 'TRUE',
          redirectUrl: 'https://booking2.airasia.com/CreditStatusLogin.aspx?culture=en-GB'
        }
      ]
    },
    {
      logoutButton: [
        {
          icon: '',
          id: 'logout',
          label: 'Log out',
          newTab: 'FALSE',
          redirectionUrl: ''
        }
      ]
    }
  ],
  loginTooltip: [
    {
      data: [
        {
          description: 'Log into get BIG Member discounts and also redeem your unlimited pass',
          loginButtonText: 'Log in/Sign up',
          signupButtonText: '',
          title: 'Log in now for BIG Member discounts'
        }
      ]
    }
  ],
  recommendedCurrencyList: [
    {
      data: ''
    }
  ],
  recommendedLocaleList: [
    {
      data: ''
    }
  ],
  translations: [
    {
      data: [
        {
          currency: 'Choose a currency',
          locale: 'Choose a language',
          mobileCurrencyLabel: 'Currency',
          mobileLocaleLabel: 'Language',
          otherCurrency: 'Other supported currency',
          otherLocale: 'Other supported languages',
          popularCurrency: 'Suggested currencies',
          popularLocale: 'Popular languages',
          settings: 'Settings'
        }
      ]
    }
  ]
}
